export const on = {
  selector: '[data-on]',
  reactive: true,

  run(el, data, root) {
    if (el._x_on_cleanup) el._x_on_cleanup();

    const raw = el.getAttribute('data-on') || el.getAttribute('x-on');
    if (!raw) return;

    const [event, code] = raw.split(':').map(s => s.trim());

    const handler = () => {
      try {
        // Bind context so variables like `lang` work
        const context = data;
        
        // Wrap in arrow function and call immediately, with `data` bound as `this`
        const fn = new Function(`with (this) { return (${code})() }`);
        fn.call(context);
      } catch (e1) {
        try {
          // Try as plain expression (e.g., lang = 'en')
          const fn = new Function(`with (this) { ${code} }`);
          fn.call(data);
        } catch (e2) {
          // Fallback: method by name
          if (typeof root.__x?.[code] === 'function') {
            root.__x[code]();
          } else {
            console.error(`data-on handler failed for code: "${code}"`, e2);
          }
        }
      }
    };

    el.addEventListener(event, handler);

    el._x_on_cleanup = () => {
      el.removeEventListener(event, handler);
      delete el._x_on_cleanup;
    };
  }
};
